import * as React from 'react'
import { Segment, Grid, Container, Header, List, Icon, Image } from 'semantic-ui-react'
export const Footer: React.SFC = () => {
  return (
    <Segment inverted={true} vertical={true} style={{ padding: '3em 0em' }}>
      <Container>
        <Grid inverted={true} stackable={true}>
          <Grid.Row>
            <Grid.Column width={3}>
              <Header inverted={true} as="h2" content="EZVALUE" />
              <List inverted={true} style={{ fontSize: '15px' }}>
                <List.Item><Icon name="phone" />   0966 026 214</List.Item>
                <List.Item><Icon name="mail" />   ezvaluevn@gmail.com</List.Item>
                <List.Item><Icon name="home" />   ezvalue.vn</List.Item>
              </List>
            </Grid.Column>
            <Grid.Column width={3}>
              <Header inverted={true} as="h2" content="Dịch vụ" />
              <List inverted={true} style={{ fontSize: '15px' }}>
                <List.Item>Mua và bán value 5etop</List.Item>
              </List>
            </Grid.Column>
            <Grid.Column width={4}>
              <Header as="h2" inverted={true}>
                Hợp tác
              </Header>
              <List inverted={true} style={{ fontSize: '15px' }}>
                <List.Item>Sản phẩm của
                  <a target="_blank" href="https://www.facebook.com/kuhau2103"> KuhAu </a>
                </List.Item>
                <List.Item>Phát triển bởi Thanhhung94, KuChit</List.Item>
              </List>
            </Grid.Column>
            <Grid.Column width={6}>
            <Image
              as={'a'}
              href={'/pick'}
              src={'/img/ezz.png'}
              size={'tiny'}
              floated={'right'}
            />
            </Grid.Column>
          </Grid.Row>
        </Grid>
        <br /><br />
        <Grid>
          <Grid.Row>
            <Header as="h4" inverted={true}>
              © 2018 - Ezvalue.vn
              </Header>
          </Grid.Row>
        </Grid>
      </Container>
    </Segment>
  )
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/HomeRoll/components/Footer.tsx